import { singleAnalysis, interactAnalysis } from "../services/analysis";

export default function useAnalysis() {
  async function getOne(encodedId: string, isBackground: boolean) {
    return singleAnalysis(encodedId, isBackground);
  }

  async function createAnalysisInteraction(
    encodedId: string,
    interaction: "like" | "dislike"
  ): Promise<number> {
    return interactAnalysis(encodedId, interaction);
  }

  return {
    getOne,
    createAnalysisInteraction,
  };
}
